import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { disallowBroadcast } from 'features/permissions/actions';

export function* disallowBroadcastSaga(action: ReturnType<typeof disallowBroadcast>) {
  logger
    .remote({ action: true, tier: 1 })
    .info(`The user disallowed broadcast to the user with id=${action.payload}`);

  yield call(SignalingSocket.send, {
    event: 'disallowBroadcast',
    data: {
      id: action.payload,
    },
  });
}
